import Icon from "@/components/Icon"

const APP_NAME = "HIVED Team"

const AppIcon = ({ className }: { className: string }) => (
  <span
    className={`flex shrink-0 items-center justify-center bg-palette-honeycomb500 ${className}`}
  >
    <Icon name="hivedH" className="h-1/2 w-1/2 text-palette-jungleGreen900" />
  </span>
)

// Sized for a 6.1 inch phone, so wrapping is close to the phones drivers use, not exact.
export default function PushPreview({ title, body }: { title: string; body: string }) {
  const shownTitle = title.trim() || "Push title"
  const shownBody = body.trim() || "Push text"

  return (
    <div className="space-y-3 rounded-lg border border-palette-jungleGreen200 bg-white p-4">
      <span className="flex items-center gap-1.5 text-xs font-medium text-palette-jungleGreen600">
        <Icon name="infoCircle" className="h-3.5 w-3.5 text-current" />
        Notification preview
      </span>

      <section aria-label="iPhone preview" className="space-y-1.5">
        <p className="text-xs font-medium text-palette-jungleGreen600">iPhone</p>
        <div className="w-[360px] max-w-full rounded-xl bg-palette-jungleGreen700 p-2">
          <div className="flex gap-2.5 rounded-[22px] bg-white/90 p-3 font-[-apple-system,BlinkMacSystemFont,system-ui,sans-serif] text-[15px] leading-5 text-palette-jungleGreen900">
            <AppIcon className="h-[38px] w-[38px] rounded-[9px]" />
            <div className="min-w-0 flex-1">
              <div className="flex items-baseline gap-2">
                <p className="min-w-0 flex-1 truncate font-semibold">{shownTitle}</p>
                <span className="shrink-0 text-[13px] text-palette-jungleGreen500">now</span>
              </div>
              <p className="line-clamp-4 whitespace-pre-line">{shownBody}</p>
            </div>
          </div>
        </div>
      </section>

      <section aria-label="Android preview" className="space-y-1.5">
        <p className="text-xs font-medium text-palette-jungleGreen600">
          Android, before it's expanded
        </p>
        <div className="w-[360px] max-w-full rounded-xl bg-palette-jungleGreen700 p-2">
          <div className="flex gap-3 rounded-[20px] bg-white p-3 font-[Roboto,system-ui,sans-serif] text-sm text-palette-jungleGreen900">
            <AppIcon className="h-9 w-9 rounded-full" />
            <div className="min-w-0 flex-1">
              <p className="text-xs text-palette-jungleGreen500">{APP_NAME} · now</p>
              <p className="truncate font-medium">{shownTitle}</p>
              <p className="truncate text-palette-jungleGreen600">{shownBody}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
